import bus from '../../components/common/bus';
export default{
    created() {
        if(!this.$router.currentRoute.meta.perm){
            // TODO 加载权限内容，对比有没有权限
            if(true){
                bus.$emit('close_menu_tags',this.$router.currentRoute.path)
                this.$router.push('/403');
            }
        }
    },
    methods:{
        // 返回首页
        goHome(){
            this.$router.push('/home')
        },
        goBack(){
            bus.$emit('close_menu_tags',this.$router.currentRoute.path)
        }
    }
}